/**
 * "Aug 31, 2026" — the app-standard short date. en-US, viewer timezone,
 * year always shown. Accepts a Date, a parseable date string, or epoch
 * milliseconds; an unparseable input renders as "Invalid Date" rather
 * than throwing, so call sites keep their own guards and fallbacks.
 */
export function formatShortDate(input: Date | string | number): string {
  const d = input instanceof Date ? input : new Date(input);
  return d.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}
